<template>
  <div class="checkout-item-description">
    <h6>{{ item.label }}</h6>
    <span v-if="hasSubscription">
      Subscription duration: {{ getSubscriptionDuration(item) }}
    </span>
    <br v-if="hasSubscription" />
    <br />
    <span style="color: rgb(209, 108, 0)">
      <strong>
        {{ getItemMeta(item, "cycle_price") | currency }}
        <small>{{ appCurrency }}</small>
        <i>per {{ getPeriod(item) }}</i>
      </strong>
      <span v-if="hasAddon">
        + {{ addonPrice | currency }} <small>{{ appCurrency }}</small>
        {{ addonName }}
      </span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  filters: {
    currency(val) {
      return `$${parseFloat(val).toFixed(2)}`;
    },
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasSubscription() {
      return this.item.has_subscription;
    },
    hasAddon() {
      return this.item.add_on.length > 0;
    },
    addonPrice() {
      return this.item.add_on[0].amount;
    },
    addonName() {
      return this.item.add_on[0].name;
    },
    ...mapGetters({
      appCurrency: "checkout/currency",
    }),
  },
  methods: {
    getItemMeta(item, value) {
      const data = item.item_meta.find((meta) => meta.item_meta === value);
      return data.item_value;
    },
    getPeriod(item) {
      const period = this.getItemMeta(item, "period");
      if (period === "month") return "month";
      if (period === "QTY") return "unit";
      return "year";
    },
    getSubscriptionDuration(item) {
      const duration = this.getItemMeta(item, "duration");
      const period = this.getItemMeta(item, "period");

      switch (period) {
        case "month":
          return `${duration} months`;
        case "year":
          return `${duration} year`;
        case "2year":
          return `2 years`;
        case "3year":
          return `3 years`;
        default:
          return `${duration} ${period}`;
      }
    },
  },
};
</script>

<style scoped>
.checkout-item-description {
  margin-bottom: 2rem;
}

.checkout-item-description h6 {
  font-weight: bold;
  margin-bottom: 5px;
}
</style>
